import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const CheckLine = ({ width = 18, height = 18, fill = '#14B8B0', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.16253 11.3625L13.5188 5.00625C13.6688 4.85625 13.8438 4.78125 14.0438 4.78125C14.2438 4.78125 14.4188 4.85625 14.5688 5.00625C14.7188 5.15625 14.7938 5.33438 14.7938 5.54063C14.7938 5.74688 14.7188 5.925 14.5688 6.075L7.68753 12.975C7.53753 13.125 7.36253 13.2 7.16253 13.2C6.96253 13.2 6.78753 13.125 6.63753 12.975L3.41253 9.75C3.26253 9.6 3.19066 9.42188 3.19691 9.21563C3.20316 9.00938 3.28128 8.83125 3.43128 8.68125C3.58128 8.53125 3.75941 8.45625 3.96566 8.45625C4.17191 8.45625 4.35003 8.53125 4.50003 8.68125L7.16253 11.3625Z"
        fill={fill}
      />
    </Svg>
  );
};

export default CheckLine;
